import { Box } from '@mui/material'
import { FoxButton } from '../../components/common/FoxButton'
import { FoxModalDialog } from '../../components/common/FoxModalDialog'
import { FoxTypography } from '../../components/common/FoxTypography'

type DeleteActiveListingConfirmationModalProps = {
    open: boolean
    onClose: (result: boolean) => void
}

export const DeleteActiveListingConfirmationModal = ({ open, onClose }: DeleteActiveListingConfirmationModalProps) => {
    const handleDelete = async (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation()
        onClose(true)
    }

    return (
        <FoxModalDialog open={open} title={'Delete active listing?'} leftButtonKind={'close'} onClose={() => onClose(false)} closeOnBackdropClick>
            <Box sx={{ textAlign: 'center' }}>
                <FoxTypography variant='body2' sx={{ marginBottom: '8px' }}>
                    Are you sure you want to delete this listing?
                </FoxTypography>
                <FoxTypography variant='body2' sx={{ marginBottom: '8px' }}>
                    The listing will be delisted from all active marketplaces.
                </FoxTypography>
                <FoxButton
                    primary
                    variant='contained'
                    onFoxClick={{ kind: 'button', onClick: handleDelete }}
                    text={'Delete active listing'}
                    sx={{ justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}
                />
            </Box>
        </FoxModalDialog>
    )
}
